const DEVELOPMENT_ENVIRONMENT = 'development';
const BETA_SOFTWARE_ENVIRONMENT = 'beta';
const PROVES_ENVIRONMENT = 'proves';
const PREPRODUCTION_ENVIRONMENT = 'preproduction';
const PRODUCTION_ENVIRONMENT = 'production';
const DEFAULT_ENVIRONMENT = DEVELOPMENT_ENVIRONMENT;

const environments = {
    [DEVELOPMENT_ENVIRONMENT]: {
        JSON_URL: 'https://static-pre.meteo.cat/ginys/',
        BASE_URL: 'http://localhost:3000/',
        ROUTER_BASENAME: null,
    },
    [BETA_SOFTWARE_ENVIRONMENT]: {
        JSON_URL: 'https://static-m.meteo.cat/ginys/',
        BASE_URL: 'https://ginys.beta.barcelona/',
        ROUTER_BASENAME: null,
    },
    [PROVES_ENVIRONMENT]: {
        JSON_URL: 'https://static-pre.meteo.cat/ginys/',
        BASE_URL:
            'http://static-proves.s3-website-eu-west-1.amazonaws.com/ginys/',
        ROUTER_BASENAME: '/ginys',
    },
    [PREPRODUCTION_ENVIRONMENT]: {
        JSON_URL: 'https://static-pre.meteo.cat/ginys/',
        BASE_URL: 'https://static-pre.meteo.cat/ginys/',
        ROUTER_BASENAME: '/ginys',
    },
    [PRODUCTION_ENVIRONMENT]: {
        JSON_URL: 'https://static-m.meteo.cat/ginys/',
        BASE_URL: 'https://static-m.meteo.cat/ginys/',
        ROUTER_BASENAME: '/ginys',
    },
};

const getEnvironmentName = () => {
    if (
        process && // eslint-disable-line
        process.env && // eslint-disable-line
        process.env.REACT_APP_ENVIRONMENT // eslint-disable-line
    ) {
        return process.env.REACT_APP_ENVIRONMENT; // eslint-disable-line
    } else return DEFAULT_ENVIRONMENT;
};

export const getEnvironment = () => {
    const environment = getEnvironmentName();
    return environments[environment];
};



// WEBPACK FOOTER //
// ./src/config/environment.js